import { CampaignId } from 'modules/campaigns/types/campaign-interface'

export const getCampaignStepsListNextjsUrl = (campaignId: CampaignId) => `/campaigns/${campaignId}`
